import gql from "graphql-tag";

export default gql`
  mutation createSource($sourceInput: SourceInputInput, $customerId: ID) {
    createSource(sourceInput: $sourceInput, customerId: $customerId) {
      id
      type
      description
      brand
      model
      serial
      owner
      publicInterface {
        adminUrl
        streamTcpUrl
        ptzControllerPort
      }
      ownedByPartnerId
      lastChecked
      lastStatus
    }
  }
`;
